module.exports = __webpack_public_path__ + "img/banner-insights.485d25f7.jpg";